export const addQuestionImage = (payload?: any) => ({
    type: "@saga/QUESTION_ADD_IMAGE",
    payload
});

